import styled, { css } from 'styled-components';
import Spinner, { SpinnerSVG, SpinnerText } from '@anwb/spinner';
import { stylePropertiesToCss } from '@anwb/style-mixins';
import { pxToRem } from '@anwb/style-utilities';
import { ANWBDefault } from '@anwb/theme';
import Typography from '@anwb/typography';
import { getGenericInputPaddingStyles, getOnDarkStyles, getOnLightStyles, getOnMediumStyles, } from '../../../styles/common.styled';
const SPINNER_SIZE = 30;
const MIN_HEIGHT = 128;
/**
 * Textarea Container
 */
export const textareaContainerStyles = ({ theme, $invalid, $colorContext, $color, }) => css `
	width: 100%;
	height: auto;
	min-height: ${pxToRem(MIN_HEIGHT)};
	padding: ${pxToRem(theme.spacing['300'])};
	border-style: solid;
	border-color: ${theme.colors.medium.borderFormField};
	border-width: 0 0 ${pxToRem(theme.borderWidth['2'])} 0;
	border-radius: ${theme.borderRadius.s}px ${theme.borderRadius.s}px 0 0;
	background-color: ${theme.colors.extralight.bgFormField};
	overflow: auto;
	resize: vertical;
	background-image: none;
	appearance: none;

	${getGenericInputPaddingStyles({ theme, $invalid, $color })}

	&::placeholder {
		color: ${theme.colors.informative.textFormField};

		${stylePropertiesToCss(Object.assign(Object.assign({}, theme.typography.formFields['100FieldHintText']), { fontStyle: theme.name === ANWBDefault.name ? 'Italic' : 'Normal' }))}
	}

	${$colorContext === 'on-light' && getOnLightStyles({ theme, $invalid, $color })}

	${$colorContext === 'on-medium' && getOnMediumStyles({ theme, $invalid, $color })}

	${$colorContext === 'on-dark' && getOnDarkStyles({ theme, $invalid, $color })}

	&:disabled {
		color: ${theme.colors.medium.textInactive};
		border-color: ${theme.colors.medium.borderFormField};
		background-color: ${theme.colors.extralight.bgFormFieldDisabled};

		${$colorContext === 'on-medium' &&
    css `
			color: ${theme.colors.medium.textInactiveOnMedium};
			background-color: ${theme.colors.light.bgFormFieldDisabledOnMedium};
		`}

		&::placeholder {
			color: ${theme.colors.medium.textInactive};
		}
	}
`;
export const TextareaContainer = styled(Typography).attrs({
    tagName: 'textarea',
    variant: 'field-text',
}) `
	${textareaContainerStyles}
`;
/**
 * Textarea SpinnerWrapper
 */
export const textareaWrapperStyles = () => css `
	display: flex;
	position: relative;
	width: 100%;
`;
export const TextareaWrapper = styled.div `
	${textareaWrapperStyles}
`;
/**
 * Textarea Spinner
 */
export const textareaSpinnerStyles = ({ theme }) => css `
	opacity: 1;
	position: absolute;
	top: ${pxToRem(theme.spacing[200])};
	right: ${pxToRem(theme.spacing[200])};

	${SpinnerSVG} {
		width: ${pxToRem(SPINNER_SIZE)};
		height: ${pxToRem(SPINNER_SIZE)};
	}

	${SpinnerText} {
		white-space: nowrap;
	}
`;
export const TextareaSpinner = styled(Spinner) `
	${textareaSpinnerStyles}
`;
//# sourceMappingURL=textarea.styled.js.map